import { createContextWithHooks } from '@/shared/utils/react';

// The id a ModalInstanceHost was spawned with. Minimizable modal primitives
// adopt it as their registry/dock id, so the instance list, the host and the
// dock all share ONE id per draft.
const modalInstanceContext = createContextWithHooks<string>('ModalInstance');

export const useModalInstanceId = modalInstanceContext.useContextOptional;

export default modalInstanceContext;
